import { gql } from "@apollo/client";

export const GET_TRACK_LIST = gql`
  query getTrackList($wagerProfile: String!) {
    pastTracks(profile: $wagerProfile) {
      code
      name
      location {
        city
        state
        country
      }
      imageName
      imageLink
    }
  }
`;

export default GET_TRACK_LIST;
